ApexDonut

<template>
  <b-card>
    <vue-apex-charts
      ref="pieChart"
      type="pie"
      height="350"
      :options="pieChart.chartOptions"
      :series="pieChart.series"
    />
  </b-card>
</template>

<script>
import { BCol, BRow, BCard, BCardTitle, BCardSubTitle } from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import * as apiDashboard from "@/store/api/dashboard/index.js";
import * as userData from "@/auth/localStorageUtils.js";
import chartColor from "./ChartColor";

export default {
  components: {
    VueApexCharts,
    BCard,
    BCardTitle,
    BCardSubTitle,
    BCol,
    BRow,
  },
  props: {
    issueName: {
      type: String,
      default: "",
    },
    titleText: {
      type: String,
      default: "",
    },
    filter: {
      type: Object,
      default: () => ({
        year: new Date().getFullYear().toString(),
        yearEnd: new Date().getFullYear().toString(),
        startDate: "",
        endDate: "",
        userId: userData.userId(),
        departmentId: userData.departmentId(),
      }),
    },
  },
  data() {
    return {
      chartColor,
      min: 1,
      max: 100,
      seriesCustomize: [], // apiDashboard
      labelsCustomize: [],
      pieChart: {
        series: [], // seriesCustomize
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
              tools: {
                download: false,
              },
            },
          },
          title: {
            text: this.titleText,
            align: "left",
            style: {
              fontSize: "18px",
            },
          },
          legend: {
            show: true,
            position: "right",
            width: "280",
          },
          colors: [
            // colors each series
          ],
          dataLabels: {
            enabled: true,
            style: {
              fontSize: "10px",
              colors: ["#000000"],
            },
            formatter(val) {
              // eslint-disable-next-line radix
              // return `${parseInt(val)}%`;
              return `${val.toFixed(2)}%`;
            },
          },
          plotOptions: {
            pie: {
              labels: {
                show: false,
                name: {
                  fontSize: "1rem",
                  // fontFamily: "Montserrat",
                },
                value: {
                  fontSize: "1rem",
                  // fontFamily: "Montserrat",
                  formatter(val) {
                    // eslint-disable-next-line radix
                    // return `${parseInt(val)}%`
                    return `${parseInt(val)}`;
                  },
                },
                total: {
                  show: false,
                  fontSize: "1.5rem",
                  label: "Operational",
                  formatter() {
                    return "31%";
                  },
                },
              },
            },
          },
          labels: [], // ได้จาก apiDashboard
          responsive: [
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 380,
                },
                legend: {
                  position: "right",
                },
              },
            },
            {
              breakpoint: 576,
              options: {
                chart: {
                  height: 320,
                },
                plotOptions: {},
              },
            },
          ],
          noData: {
            text: "ไม่พบข้อมูล",
            align: "center",
            verticalAlign: "middle",
            offsetX: 0,
            offsetY: 0,
            style: {
              color: undefined,
              fontSize: "18px",
              fontFamily: undefined,
            },
          },
        },
      },
    };
  },
  mounted() {
    if (chartColor && chartColor.color) {
      this.max = chartColor.color.length;
    }

    if (this.issueName === "WEB_SERVICE") {
      this.funcGetWebService(this.filter);
    } else if (this.issueName === "CONTINUE_TERMINATE_STATUS") {
      // this.funcGetContinueAndTerminateStatus(this.filter);
    } else if (this.issueName === "RESULTS_THE_LEGAL_DEPARTMENT_INQUIRY") {
      this.funcGetResultsTheLegalDeptInquiry(this.filter);
    } else if (this.issueName === "COMPLAINT_TO_OFFICER") {
      this.funcGetComplaintSendToOfficer(this.filter);
    } else if (this.issueName === "TRACKING_COMPLAINT_STATUS") {
      this.funcGetTrackingComplaintStatus(this.filter);
    } else if (this.issueName === "DOCUMENT_STATUS_OFFICER") {
      this.funcGetDocumentStatusForOfficer(this.filter);
    } else if (this.issueName === "OUTSITE_DEPARTMENT") {
      this.funcGetComplaintSendToOutSiteDepartment(this.filter);
    }
  },
  created() {
    window.addEventListener("resize", this.myEventHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  methods: {
    async getRandomChartColor(n) {
      //console.log"piechart.randomchartcolor .n", n);

      const result = [];
      const colors = [...this.chartColor.color];
      //console.log"piechart.randomchartcolor .colors", colors);

      while (result.length < n) {
        const shuffled = colors.sort(() => Math.random() - 0.5);
        const remaining = n - result.length;
        const takeCount = Math.min(remaining, shuffled.length);
        result.push(...shuffled.slice(0, takeCount));
      }

      //console.log"piechart.randomchartcolor .result", result);

      this.pieChart.chartOptions.colors = [...result];
      // return [...result];

      // //console.log
      //   "piechart.randomchartcolor .piechart.chartoption",
      //   this.pieChart.chartOptions.colors
      // );
    },
    // funcGetContinueAndTerminateStatus(obj) {
    //   const self = this;
    //   apiDashboard
    //     .GetPieChart_ContinueAndTerminateStatus(obj)
    //     .then((response) => {
    //       //console.log
    //         "@GetPieChart_ContinueAndTerminateStatus response",
    //         response
    //       );

    //       if (response.data.data) {
    //         self.seriesCustomize = response.data.data.map(
    //           (value) => value.total
    //         );
    //         self.labelsCustomize = response.data.data.map(
    //           (value) => value.name
    //         );
    //         // //console.log
    //         //   "screeningPieWebService-seriesCustomize",
    //         //   self.seriesCustomize
    //         // );
    //         // //console.log
    //         //   "screeningPieWebService-labelsCustomize",
    //         //   self.labelsCustomize
    //         // );

    //         self.pieChart.series = self.seriesCustomize;
    //         if (self.seriesCustomize) {
    //           this.getChartColor(self.seriesCustomize.length);
    //         }
    //         self.pieChart.chartOptions.labels = self.labelsCustomize;
    //         self.updatePieChart();
    //       }
    //     })
    //     .catch((error) => {
    //       //console.log"error", error);
    //     });
    // },
    async funcGetWebService(obj) {
      const self = this;
      apiDashboard
        .GetPieChart_WebService(obj)
        .then(async (response) => {
          //console.log"piechart.webservice .response", response);
          if (
            response &&
            response.data &&
            response.data.data &&
            response.data.data.length > 0
          ) {
            self.seriesCustomize = response.data.data.map(
              (value) => value.total
            );
            self.labelsCustomize = response.data.data.map(
              (value) => `${value.name} (${value.total})`
            );

            if (self.seriesCustomize) {
              self.pieChart.series = self.seriesCustomize;
            }
            if (self.seriesCustomize) {
              await this.getRandomChartColor(response.data.data.length);
            }
            if (self.labelsCustomize) {
              self.pieChart.chartOptions.labels = self.labelsCustomize;
            }

            await self.updatePieChart();
          }
        })
        .catch((error) => {
          //console.log"piechart.webservice .error", error);
        });
    },
    // funcGetWebService(obj) {
    //   const self = this;
    //   // const params = {
    //   //   year: self.year.toString(),
    //   //   departmentId: self.departmentId,
    //   // };
    //   apiDashboard
    //     .GetWebService(obj)
    //     .then((response) => {
    //       //console.log"@funcGetWebService response", response);

    //       self.seriesCustomize = response.data.data.map((value) => value.total);
    //       self.labelsCustomize = response.data.data.map((value) => value.name);
    //       // //console.log
    //       //   "screeningPieWebService-seriesCustomize",
    //       //   self.seriesCustomize
    //       // );
    //       // //console.log
    //       //   "screeningPieWebService-labelsCustomize",
    //       //   self.labelsCustomize
    //       // );

    //       self.pieChart.series = self.seriesCustomize;
    //       if (self.seriesCustomize) {
    //         this.getChartColor(self.seriesCustomize.length);
    //       }
    //       self.pieChart.chartOptions.labels = self.labelsCustomize;
    //       self.updatePieChart();
    //     })
    //     .catch((error) => {
    //       //console.log"error", error);
    //     });
    // },
    funcGetResultsTheLegalDeptInquiry(obj) {
      const self = this;
      // const params = {
      //   year: self.year.toString(),
      //   departmentId: self.departmentId,
      // };
      apiDashboard
        .GetPieChart_ResultsTheLegalDeptInquiry(obj)
        .then(async (response) => {
          //console.log"@funcGetResultsTheLegalDeptInquiry response", response);
          if (
            response &&
            response.data &&
            response.data.data &&
            response.data.data.length > 0
          ) {
            self.seriesCustomize = response.data.data.map(
              (value) => value.total
            );
            self.labelsCustomize = response.data.data.map(
              (value) => `${value.name} (${value.total})`
            );

            self.pieChart.series = self.seriesCustomize;
            if (self.seriesCustomize) {
              await this.getRandomChartColor(response.data.data.length);
            }
            self.pieChart.chartOptions.labels = self.labelsCustomize;
            self.updatePieChart();
          }
        })
        .catch((error) => {
          //console.log"error", error);
        });
    },
    funcGetComplaintSendToOfficer(obj) {
      const self = this;
      // const params = {
      //   year: self.year.toString(),
      //   departmentId: self.departmentId,
      // };
      apiDashboard
        .GetPieChart_ComplaintSendToOfficer(obj)
        .then(async (response) => {
          //console.log"@funcGetComplaintSendToOfficer response", response);

          self.seriesCustomize = response.data.data.map((value) => value.total);
          self.labelsCustomize = response.data.data.map(
            (value) => `${value.name} (${value.total})`
          );
          // //console.log
          //   "screeningPieWebService-seriesCustomize",
          //   self.seriesCustomize
          // );
          // //console.log
          //   "screeningPieWebService-labelsCustomize",
          //   self.labelsCustomize
          // );

          self.pieChart.series = self.seriesCustomize;
          if (self.seriesCustomize) {
            // this.getChartColor(self.seriesCustomize.length);
            await this.getRandomChartColor(response.data.data.length);
          }
          self.pieChart.chartOptions.labels = self.labelsCustomize;
          self.updatePieChart();
        })
        .catch((error) => {
          //console.log"error", error);
        });
    },
    funcGetTrackingComplaintStatus(obj) {
      const self = this;
      apiDashboard
        .GetPieChart_TrackingComplaintStatus(obj)
        .then(async (response) => {
          //console.log"piechart.trackingcomplaintstatus .response", response);

          self.seriesCustomize = response.data.data.map((value) => value.total);
          self.labelsCustomize = response.data.data.map(
            (value) => `${value.name} (${value.total})`
          );

          if (self.seriesCustomize) {
            self.pieChart.series = self.seriesCustomize;
          }
          if (self.seriesCustomize) {
            await this.getRandomChartColor(response.data.data.length);
          }
          if (self.labelsCustomize) {
            self.pieChart.chartOptions.labels = self.labelsCustomize;
          }

          self.updatePieChart();
        })
        .catch((error) => {
          //console.log"piechart.trackingcomplaintstatus .error", error);
        });
    },
    funcGetDocumentStatusForOfficer(obj) {
      const self = this;
      // const params = {
      //   year: self.year.toString(),
      //   departmentId: self.departmentId,
      // };
      apiDashboard
        .GetPieChart_DocumentStatusForOfficer(obj)
        .then(async (response) => {
          //console.log"@funcGetDocumentStatusForOfficer response", response);

          self.seriesCustomize = response.data.data.map((value) => value.total);
          self.labelsCustomize = response.data.data.map(
            (value) => `${value.name} (${value.total})`
          );
          // //console.log
          //   "screeningPieWebService-seriesCustomize",
          //   self.seriesCustomize
          // );
          // //console.log
          //   "screeningPieWebService-labelsCustomize",
          //   self.labelsCustomize
          // );

          self.pieChart.series = self.seriesCustomize;
          if (self.seriesCustomize) {
            // this.getChartColor(self.seriesCustomize.length);
            await this.getRandomChartColor(response.data.data.length);
          }
          self.pieChart.chartOptions.labels = self.labelsCustomize;
          self.updatePieChart();
        })
        .catch((error) => {
          //console.log"error", error);
        });
    },
    funcGetComplaintSendToOutSiteDepartment(obj) {
      const self = this;
      // const params = {
      //   year: self.year.toString(),
      //   departmentId: self.departmentId,
      // };
      apiDashboard
        .GetPieChart_ComplaintSendToOutSiteDepartment(obj)
        .then(async (response) => {
          //console.log
          //   "@funcGetComplaintSendToOutSiteDepartment response",
          //   response
          // );

          self.seriesCustomize = response.data.data.map((value) => value.total);
          self.labelsCustomize = response.data.data.map(
            (value) => `${value.name} (${value.total})`
          );
          // //console.log
          //   "screeningPieWebService-seriesCustomize",
          //   self.seriesCustomize
          // );
          // //console.log
          //   "screeningPieWebService-labelsCustomize",
          //   self.labelsCustomize
          // );

          self.pieChart.series = self.seriesCustomize;
          if (self.seriesCustomize) {
            // this.getChartColor(self.seriesCustomize.length);
            await this.getRandomChartColor(response.data.data.length);
          }
          self.pieChart.chartOptions.labels = self.labelsCustomize;
          self.updatePieChart();
        })
        .catch((error) => {
          //console.log"error", error);
        });
    },
    updatePieChart() {
      this.$refs["pieChart"].updateSeries([
        {
          data: this.pieChart.series,
        },
        false,
        true,
      ]);

      this.$refs["pieChart"].updateOptions({
        labels: this.pieChart.chartOptions.labels,
      });

      this.$refs["pieChart"].refresh();
    },
    myEventHandler(e) {
      this.$refs["pieChart"].refresh();
    },
  },
};
</script>